
  <div id="id01" class="modal">

    <form class="modal-content animate">
      <div class="imgcontainer" style="background-color: #183E6D;">
        <img src="/Content/img/logo.png" alt="Pernod Ricard" class="avatar">
      </div>
      <div class="container">
        <label for="uname"><strong>Email</strong></label>
        <input type="text" placeholder="Enter Email" name="uname" required>
        <label for="psw"><strong>Password</strong></label>
        <input type="password" placeholder="Enter Password" name="psw" required>
        <label>
          <input  type="checkbox" checked="checked" name="remember"> Remember me
        </label>
        <a  routerLink="/home" class="btn btn-lg btn-color btn-block"> <button type="button">Login</button></a>
      </div>
    </form>
  </div>


